import * as React from "react";
import * as typefaces from "./typefaces";
import * as colors from "./colors";
import { markdown } from "catalog";
import { css } from "react-emotion";
const typeSample = css `
  background: white;
  color: black;
  width: 50%;
  padding: 25px;
  margin: 20px 0;
`;
const TypeSample = ({ name, className, short }) => {
    const text = short
        ? "Jackie will budget for the zoology equipment. 0123456789"
        : "Jackie will budget for the most expensive zoology equipment and Zelda might fix the job growth plans very quickly on Monday. 0123456789";
    return (<section className={typeSample}>
      <h1 className={css `
          font-family: Roboto;
          font-weight: 400;
          font-size: 1em;
          margin: 0 0 1em 0;
          color: #bbb;
        `}>
        {name}
      </h1>
      <div className={className}>{text}</div>
    </section>);
};
export default () => markdown `
  
## Typefaces

The typefaces file exports generated CSS class names. You probably want to use ready-made components instead.

Example component using [react-emotion](https://emotion.sh/docs/styled) implementing a typeface:

~~~code|lang-javascript
import styled from "react-emotion";
import {h1} from "./theme/typefaces";

const PageTitle = styled("h1")\`
  $\{h1\}
  color: ${colors.primaryColors.zuerichBlue};
  margin: 0 0 1em 0;
\`
~~~

## Available Typefaces

${(<React.Fragment>
      {Object.entries(typefaces)
    .filter(([k, value]) => typeof value === "string")
    .map(([k, value]) => (<TypeSample key={k} name={k} className={value}/>))}
    </React.Fragment>)}
`;



// WEBPACK FOOTER //
// ./src/theme/typefaces.docs.tsx